"use client";

import React from "react";
import Link from "next/link";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export function HomeAbout() {
  const [leftRef, leftVisible] = useScrollAnimation();
  const [rightRef, rightVisible] = useScrollAnimation();

  return (
    <section id="relume" className="px-4 md:px-16 py-12 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-12 xl:gap-32">
          <div 
            ref={leftRef}
            className={`w-full md:w-1/2 flex flex-col justify-center items-start pl-2 md:pl-8 lg:pl-16 transition-all duration-1000 ease-out ${
              leftVisible 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-8'
            }`}
          >
            <p className="mb-6 font-semibold text-black text-base md:text-lg">Movilidad</p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-black leading-tight mb-0 md:mb-2">
              Soluciones en<br className="hidden md:block" />Movimiento
            </h1>
          </div>
          <div 
            ref={rightRef}
            className={`w-full md:w-1/2 flex flex-col justify-center items-start pr-2 md:pr-8 lg:pr-16 mt-8 md:mt-0 transition-all duration-1000 ease-out delay-300 ${
              rightVisible 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-8'
            }`}
          >
            <p className="text-black text-base md:text-lg mb-8">
              En Vehículos NDC, nuestra misión es proporcionar soluciones de movilidad efectivas y accesibles. Con más de 30 años de experiencia, nos dedicamos a generar satisfacción en el mercado automotriz.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Link 
                href="/nosotros"
                className="bg-black text-white px-8 py-3 text-base font-medium text-center hover:bg-gray-800 transition-colors duration-300 flex items-center justify-center"
              >
                Acerca de NDC
              </Link>
              <Link 
                href="/contactos"
                className="bg-white text-black border border-black px-8 py-3 text-base font-medium text-center hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
              >
                Contáctanos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
